const UTILITY = 'UTILITY'
const GENERATOR = 'GENERATOR'

const objects = {
    [UTILITY]: {
        type: UTILITY,
        label: 'Utility',
    },
    [GENERATOR]: {
        type: GENERATOR,
        label: 'Generator',
    },
}

export default Object.freeze(objects)
export const ordered = Object.freeze([objects.UTILITY, objects.GENERATOR])

export const byValue = (value) => {
    return objects[value?.toUpperCase()]
}
